import { Helmet } from "react-helmet-async";
import { SITE } from "../lib/site";

/**
 * PageMeta — Sets per-page <title> and meta tags.
 * Usage: <PageMeta title="Products" description="Browse..." />
 */
const PageMeta = ({
  title,
  description,
  image,
  canonical,
}) => {
  const fullTitle = title
    ? `${title} | ${SITE.shortName} Manufacturing`
    : `${SITE.name} — Premium Pickleball OEM/ODM`;

  const metaDesc =
    description ||
    "Premium OEM/ODM and private-label pickleball paddles, tournament balls, nets, and court equipment. Factory-direct from Sialkot, Pakistan.";

  const siteUrl = "https://pickleballgearz.com";
  const ogImage = image || `${siteUrl}/pickleball_gearz_logo-new.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={SITE.name} />
      {canonical && <meta property="og:url" content={canonical} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={ogImage} />

      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default PageMeta;
